import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { CURRENCY_SYMBOL } from "../../../common/utils";

const CompanyChartGraph = props => {
  const { graphData, stock, graphType } = props;
  const chartOptions = {
    time: {
      useUTC: false,
    },
    chart: {
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      plotBorderWidth: 0,
      zooming: {
        type: "x",
      },
    },
    title: {
      text: `${stock?.symbol} chart`,
      align: "left",
      verticalAlign: "top",
      style: {
        color: "white",
      },
    },
    xAxis: {
      type: "datetime",
      labels: {
        style: {
          color: "#8C8E95",
        },
      },
    },

    yAxis: {
      title: {
        text: false,
      },
      opposite: true,
      labels: {
        style: {
          color: "#8C8E95",
        },
      },
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },

    plotOptions: {
      area: {
        marker: {
          radius: 2,
        },
        lineWidth: 1,
        color: "#E3C050",
        // color: {
        //   linearGradient: {
        //     x1: 0,
        //     y1: 0,
        //     x2: 0,
        //     y2: 1,
        //   },
        //   stops: [
        //     [0, "rgb(199, 113, 243)"],
        //     [0.7, "rgb(76, 175, 254)"],
        //   ],
        // },
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "rgba(227, 192, 80, 0.20)"],
            [1, "rgba(227, 192, 80, 0.00)"],
          ],
        },
        states: {
          hover: {
            lineWidth: 2,
          },
        },
        threshold: null,
      },
    },

    series: [
      {
        name: `${stock?.symbol}-${stock?.exchange} Price (${stock?.currency})`,
        data: graphData,
        type: "area",
      },
    ],
    tooltip: {
      backgroundColor: "#2b2b2b",
      borderColor: "#373737",
      style: {
        color: "white",
      },
      formatter: function () {
        return `
          ${moment(this.x).format("MMM DD YYYY")}<br/>
          ${
            graphType === "datetime" ? moment(this.x).format(" h:mm A") : ""
          }<br/>
          <b>Price  <span style="color:${
            this.color
          }">\u25CF</span> ${CURRENCY_SYMBOL(stock?.currency)}${this.y}</b>`;
      },
    },
  };

  return (
    <React.Fragment>
      {chartOptions && (
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      )}
    </React.Fragment>
  );
};

export default CompanyChartGraph;
